import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/valor-logo.png';

const Footer = () => {
  return (
    <footer id="contact">
      <div className="wrap">
        <div className="foot-grid">
          <div className="foot-brand">
            <img src={logo} alt="Valor Technyx" />
            <p>Custom software for government agencies that need to move faster without breaking compliance.</p>
          </div>
          <div className="foot-col">
            <h5>Product</h5>
            <Link to="/valor-os">Valor OS</Link>
            <Link to="/counterops">CounterOps</Link>
            <Link to="/apps">Apps</Link>
          </div>
          <div className="foot-col">
            <h5>Company</h5>
            <Link to="/about">About Us</Link>
            <Link to="/#customers">Customers</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="foot-col">
            <h5>Get in touch</h5>
            <a href="mailto:hello@valortechnyx.com">hello@valortechnyx.com</a>
            <Link to="/contact">Request a briefing</Link>
          </div>
        </div>
        <div className="foot-bottom">
          <span>&copy; 2026 Valor Technyx. All rights reserved.</span>
          <span>Privacy &middot; Terms &middot; Security</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
